<div class='fullcontainer'>
<div class='timelineToolbarContainer'>
  <div class='toolbarGroup'>
    <button class='btn btn-secondary' routerLink='/workshop/defects'><i class="fas fa-arrow-left"></i> Back</button>
    <button class='btn btn-secondary' (click)='this.today()'>Today</button>
  </div>

  <div class="dateSelectorContainer">
    <button class="btn btn-nav" (click)='this.prevDay()'><i class="fas fa-chevron-left"></i></button>
    <div class="dateSelectorBox">
      <span><i class="fas fa-calendar-alt" style='font-size: 0.8rem'></i>&nbsp;&nbsp;{{ this.getFormattedDate() }}</span>
    </div>
    <button class="btn btn-nav" (click)='this.nextDay()'><i class="fas fa-chevron-right"></i></button>
  </div>

  <div class='toolbarGroup colorCodeContainer'>
    <span class='colorCodeChip'><span class='colorCodeSwatch' style='background: #64748b;'></span> Open</span>
    <span class='colorCodeChip'><span class='colorCodeSwatch' style='background: #006498;'></span> Assigned</span>
    <span class='colorCodeChip'><span class='colorCodeSwatch' style='background: #f99420;'></span> In Progress</span>
    <span class='colorCodeChip'><span class='colorCodeSwatch' style='background: #3f8f5f;'></span> Complete</span>
  </div>
</div>

<div class='timelineLayout'>

  <div class='unassignedPanel'>
    <h3 class='unassignedTitle'>Active Defects</h3>
    <p class='unassignedHint'>Drag onto a fitter's lane to assign - drag again for extra days. Sign off once the work is done.</p>

    <input type='text' class='form-control defectSearchInput' placeholder='Search reg or description...' [(ngModel)]='this.defectSearchTerm'>
    <select class='form-control defectSeveritySelect' [(ngModel)]='this.defectSeverityFilter' (ngModelChange)='this.defectSeverityFilter = +$event'>
      <option [ngValue]='-1'>All severities</option>
      @for (severity of this.severities; track severity.id) {
        <option [ngValue]='severity.id'>{{ severity.notes }}</option>
      }
    </select>

    @if (this.filteredActiveDefects().length === 0) {
      <p class='text-muted'>No matching defects</p>
    }
    @for (defect of this.filteredActiveDefects(); track defect.id) {
      <div class='unassignedCard' draggable='true' (dragstart)='this.dragStartUnassigned($event, defect)' (click)='this.openDefectPanel($event, defect.id)'>
        <span class='cardVehicle'>{{ defect.vehicle.registration }}</span>
        <span class='cardDesc'>{{ defect.description }}</span>
        <button type='button' class='signOffBtn' (click)='$event.stopPropagation(); this.signOff(defect)'><i class="fas fa-check"></i> Sign Off</button>
      </div>
    }
  </div>

  <div class='lanesWrap'>
    <div class='lanesRow'>
      @for (fitter of this.fitters; track fitter) {
        <div class='fitterLane' [class.laneAbsentLane]='this.isFitterAbsent(fitter.id)'>
          <div class='fitterLaneHeader'>
            {{ fitter.firstName }} {{ fitter.lastName }}
            @if (this.isFitterAbsent(fitter.id)) {
              <span class='absentTag'>On Leave</span>
            }
          </div>
          <div class='fitterLaneBody'
            [class.drop]='this.hoveredFitterId === fitter.id'
            [class.laneAbsentBody]='this.isFitterAbsent(fitter.id)'
            (dragenter)='this.dragEnterLane(fitter.id)'
            (dragover)='$event.preventDefault();'
            (drop)='this.onDropOnLane($event, fitter.id)'>
            @if (this.isFitterAbsent(fitter.id)) {
              <span class='laneEmptyHint'><i class="fas fa-user-slash"></i> On leave today</span>
            }
            @for (assignment of this.assignmentsFor(fitter.id); track assignment.id) {
              <div class='defectCard status-{{ assignment.workshopDefect.status }}' draggable='true'
                (dragstart)='this.dragStartAssignment($event, assignment)'
                (click)='this.openDefectPanel($event, assignment.workshopDefectId)'>
                <div class='cardTop'>
                  <span class='cardVehicle'>{{ assignment.workshopDefect.vehicle.registration }}</span>
                  <span class='cardStatus'>{{ this.statusLabel(assignment.workshopDefect.status) }}</span>
                </div>
                <div class='cardActions'>
                  <button type='button' title='Copy to next day' (click)='this.copyToNextDay($event, assignment)'><i class="fas fa-copy"></i></button>
                  <button type='button' title='Remove from this day' (click)='this.deleteAssignment($event, assignment)'><i class="fas fa-trash"></i></button>
                </div>
              </div>
            }
            @if (this.assignmentsFor(fitter.id).length === 0 && !this.isFitterAbsent(fitter.id)) {
              <span class='laneEmptyHint'>Drop here</span>
            }
          </div>
        </div>
      }
    </div>
  </div>
</div>
</div>

@if (this.isPanelOpen) {
  <div class='panelBackdrop' (click)='this.closePanel()'></div>
  <div class='editPanel'>
    <div class='editPanelHeader'>
      <h3>Defect - {{ this.panelDefect.vehicle.registration }}</h3>
      <button type='button' class='panelCloseBtn' (click)='this.closePanel()' aria-label='Close'>&times;</button>
    </div>
    <div class='editPanelBody'>
      @if (this.panelIsError) {
        <div class="alert alert-danger">Please complete all required fields</div>
      }
      @if (this.panelIsServerError) {
        <div class="alert alert-danger">Something went wrong. Please try again later.</div>
      }
      <app-workshop-defect-form [defect]='this.panelDefect'></app-workshop-defect-form>
      <button type='button' class="btn btn-success" (click)='this.savePanelDefect()'>Save</button>&nbsp;
      <button type='button' class="btn btn-danger" (click)='this.closePanel()'>Cancel</button>

      <hr />
      <app-workshop-defect-fitters [workshopDefectId]='this.panelDefect.id'></app-workshop-defect-fitters>
      <hr />
      <app-workshop-defect-parts [workshopDefectId]='this.panelDefect.id'></app-workshop-defect-parts>
    </div>
  </div>
}
